import { useCallback } from 'react';

export const usePrefabOperations = ({
  prefabs,
  selectedPrefabId,
  setEditingPrefabId,
  createUpdatePrefabsCommand,
  executeCommand,
  setPrefabs,
  setSelectedPrefabId
}) => {
  const handleDeletePrefab = useCallback((id) => {
    const cmd = createUpdatePrefabsCommand(
      prefabs,
      prefabs.filter(p => p.id !== id),
      id,
      null,
      { setPrefabs, setSelectedPrefabId }
    );
    executeCommand(cmd);
    setSelectedPrefabId(null);
  }, [prefabs, createUpdatePrefabsCommand, executeCommand, setPrefabs, setSelectedPrefabId]);

  const handleRenamePrefab = useCallback((id, newName) => {
    if (!newName || !newName.trim()) {
      setEditingPrefabId(null);
      return;
    }
    const newPrefabs = prefabs.map(p => (p.id === id ? { ...p, name: newName } : p));
    const cmd = createUpdatePrefabsCommand(prefabs, newPrefabs, selectedPrefabId, selectedPrefabId, {
      setPrefabs,
      setSelectedPrefabId
    });
    executeCommand(cmd);
    setEditingPrefabId(null);
  }, [prefabs, selectedPrefabId, createUpdatePrefabsCommand, executeCommand, setPrefabs, setSelectedPrefabId, setEditingPrefabId]);

  return {
    handleDeletePrefab,
    handleRenamePrefab
  };
};
